import { Link } from 'react-router-dom';

function warrantyType(original) {
  return (
    <Link to={`/serviceadministratorwarrantytypes/edit/${original?.id}`}>
      {original?.warrantyType || ''}
    </Link>
  );
}

function warrantyTypeCode(original) {
  return original?.warrantyTypeCode || '';
}

function status(original) {
  return original?.status ? 'Active' : 'In-Active';
}

export { warrantyType, warrantyTypeCode, status };
